
let matomo = {
    
    _paq:  window._paq = window._paq || [],
    initMatomo: function (consentGiven, siteId) {
        if (!consentGiven) {
            _paq.push(['requireCookieConsent']);
        }
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        var u = "https://telge.matomo.cloud/";
        _paq.push(['setTrackerUrl', u + 'matomo.php']);
        _paq.push(['setSiteId', siteId]);
        var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
        g.type = 'text/javascript'; g.async = true; g.src = u + 'matomo.js'; s.parentNode.insertBefore(g, s);
        matomo.initTagManager();
    },
    triggerEvent: function (url, pageTitle, consentGiven) {
        if (consentGiven === true) {
            _paq.push(['setCookieConsentGiven']);
        }
        _paq.push(['setCustomUrl', url]);
        _paq.push(['setDocumentTitle', pageTitle]);
        _paq.push(['trackPageView']);
    },

    disableRecording: function () {
        _paq.push(['HeatmapSessionRecording::disable']);
    },

    enableRecording: function () {
        _paq.push(['HeatmapSessionRecording::enable']);
    },

    initTagManager: function () {
        var _mtm = window._mtm = window._mtm || [];
        _mtm.push({ 'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start' });
        var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
        g.async = true; g.src = 'https://cdn.matomo.cloud/telge.matomo.cloud/container_6KekjbR3.js'; s.parentNode.insertBefore(g, s);
    }
};

export { matomo };